import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from '@angular/common';
import {DEFAULT_DIGITS_INFO, DEFAULT_LOCALE} from '../../utils/constants';

@Pipe({
  name: 'loyaltyCurrency'
})
export class LoyaltyCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {
  }

  transform(
    value: number | null | undefined,
    currencyCode: string = 'USD',
    display: 'symbol' | 'code' | 'name' = 'symbol',
    digitsInfo: string = DEFAULT_DIGITS_INFO,
    locale: string = DEFAULT_LOCALE
  ): string {
    return this.currencyPipe.transform(value ?? 0, currencyCode, display, digitsInfo, locale)!;
  }
}
